module.exports = __webpack_public_path__ + "img/about-page5-img-1.57b3dc3b.jpg";